import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useUpdateOffer = function (id) {
    return useApiCall(function (signal, id, payload) { return api.offer.apiOfferDataIdPut(id, payload, { signal: signal }); }, null, !!id, [id], { success: 'Offer updated', error: 'Failed to update offer' });
};
